import React from 'react';
import styles from './Footer.module.scss';
import RoundedButton from '../../../../../../components/RoundedButton/RoundedButton';
import { Popconfirm } from 'antd';

const Footer = ({ value, onUpload, onCancel }) => {
  return (
    <div className={styles.root}>
      <RoundedButton
        text="Отмена"
        onClick={onCancel}
        className={styles.btnCancel}
      />
      {value ? (
        <Popconfirm
          title="Данные по загрузке будут обновлены. Продолжить"
          okText="Да"
          cancelText="Нет"
          onConfirm={onUpload}
        >
          <RoundedButton
            text={value ? 'Обновить' : 'Загрузить'}
            className={styles.btnSubmit}
          />
        </Popconfirm>
      ) : (
        <RoundedButton
          text={value ? 'Обновить' : 'Загрузить'}
          onClick={onUpload}
          className={styles.btnSubmit}
        />
      )}
    </div>
  );
};

export default Footer;
